<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @exps="exps" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <div>
                    <el-tabs :tab-position="'top'" type="">
                        <el-tab-pane :label="$t('getapi[6020]')">
                            <div style="background: white;white-space: nowrap;overflow: auto">
                                <el-button type="primary" size="mini" @click.native.prevent="showAddMaterials">
                                    {{$t('getapi[878]')}}
                                </el-button>
                                <el-button type="primary" size="mini" @click.native.prevent="batchEdl">
                                    {{$t('getapi[7241]')}}
                                </el-button>
                            </div>
                            <el-table :data="dataSetMaterials"
                                      :height="tableHeight - reduceTableHeight"
                                      header-row-class-name="headerclass"
                                      @selection-change="handleSelectionChange" :row-class-name="tableRowClassName"
                                      border size="mini"
                                      style="width: 100%; margin-top:0px"
                                      :header-cell-style="$limits.headerClass"
                                      ref="singleTable">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="exclusively_id" label="ID"
                                                 v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code"
                                                 :label="$t('getapi[112]')" width="150"></el-table-column>
                                <el-table-column prop="number" :label="$t('getapi[1562]')" width="80">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.number" size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version"
                                                 :label="$t('getapi[113]')" width="80"></el-table-column>
                                <el-table-column :label="$t('getapi[6048]')" width="80">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                                :confirmButtonText="$t('getapi[937]')"
                                                :cancelButtonText="$t('getapi[6]')"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                :title="$t('getapi[637]')"
                                                @onConfirm="delMaterials(scope.$index)"
                                        >
                                            <el-button slot="reference" type="text" size="mini">{{ $t('getapi[3889]')
                                                }}
                                            </el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div style="position: absolute;bottom:10px">
                    <el-button type="primary" size="mini" @click.native.prevent="selectInfo(1)">{{$t('getapi[6022]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native.prevent="selectInfo(2)">{{$t('getapi[1573]')}}
                    </el-button>
                    <el-button type="primary" size="mini" @click.native.prevent="selectInfo(3)">{{$t('getapi[1566]')}}
                    </el-button>
                </div>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <div>
                    <el-tabs :tab-position="'top'" type="" v-model="activeName" style="margin-top: 5px"
                             @tab-click="selpage">
                        <el-tab-pane :label="$t('getapi[6022]')" name="1">
                            <div>
                                <el-button type="primary" size="mini" @click="transfer">{{ $t('getapi[6023]') }}
                                </el-button>
                            </div>
                            <!--<wTable id="xpane-1" :data="dataSetDetails1.DataList" :loading="loading"
                                    :header="tableHeader" @handleSelectionChange="handleSelectionChange1"
                                    :option="tableOption" @contextmenu.prevent.native="openMenu($event)"></wTable>-->
                            <div id="xpane-1">
                            <vTable
                                    :data="dataSetDetails1.DataList"
                                    :loading="loading"
                                    :header="tableHeader"
                                    :height="tableHeight - 60"
                                    queryData="FrmSimulation"
                                    @handleSelectionChange="handleSelectionChange1"
                                    @handleSelectionChangeAll="handleSelectionChangeAll"
                                    @handleSelectionChangeEnd="handleSelectionChange1"
                                    ref="singleTable1"
                            ></vTable>
                            </div>
                            <!-- <el-table
                                    :data="dataSetDetails1.DataList"
                                    v-loading="loading"
                                    size="mini"
                                    border
                                    :height="tableHeight - 60"
                                    style="width: 100%; margin-top:0px"
                                    @selection-change="handleSelectionChange1"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column
                                        v-for="item in dataSetDetails1.ColumnsList"
                                        :key="item.ColumnsField"
                                        :prop="item.ColumnsField"
                                        :label="item.ColumnsName"
                                ></el-table-column>
                            </el-table> -->
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[1573]')" name="2">
                            <div>
                                <!-- <el-button type="primary" size="mini">{{$t('getapi[922]')}}</el-button> -->
                                <el-button type="primary" size="mini" @click="transfer">{{ $t('getapi[6023]') }}
                                </el-button>
                            </div>
                            <!--<wTable id="xpane-2" :data="dataSetDetails2.DataList" :loading="loading"
                                    :header="tableHeader1" @handleSelectionChange="handleSelectionChange2"
                                    :option="tableOption" @contextmenu.prevent.native="openMenu($event)"></wTable>-->
                            <div id="xpane-2">
                            <vTable
                                    :data="dataSetDetails2.DataList"
                                    :loading="loading"
                                    :header="tableHeader1"
                                    :height="tableHeight - 60"
                                    queryData="FrmSimulation"
                                    @handleSelectionChange="handleSelectionChange2"
                                    @handleSelectionChangeAll="handleSelectionChangeAll2"
                                    @handleSelectionChangeEnd="handleSelectionChange2"
                                    ref="singleTable2"
                            ></vTable>
                            </div>
                            <!-- <el-table :data="dataSetDetails2.DataList" :height="tableHeight - 60" v-loading="loading"
                                      @selection-change="handleSelectionChange2" size="mini" style="width: 100%">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column
                                        v-for="item in dataSetDetails2.ColumnsList"
                                        :key="item.ColumnsField"
                                        :prop="item.ColumnsField"
                                        :label="item.ColumnsName"
                                ></el-table-column>
                            </el-table> -->
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[1566]')" name="3">
                            <wTable id="xpane-3" :data="dataSetDetails3.DataList" :loading="loading"
                                    :header="tableHeader2" :option="tableOption"
                                    @contextmenu.prevent.native="openMenu($event)"
                                    ref="singleTable3"></wTable>
                            <!-- <el-table :data="dataSetDetails3.DataList" :height="tableHeight - 60" v-loading="loading"
                                      size="mini" style="width: 100%">
                                <el-table-column
                                        v-for="item in dataSetDetails3.ColumnsList"
                                        :key="item.ColumnsField"
                                        :prop="item.ColumnsField"
                                        :label="item.ColumnsName"
                                ></el-table-column>
                            </el-table> -->
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <!-- 新增物料弹框 -->
        <!--<OM :isVisible="addmaterialsvisible" @addmaterials="addmaterials" ref="addmaterials"></OM>-->
        <selector :isVisible="addmaterialsvisible" :selectType="4" :isBatch=true :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="addmaterials" @dialogVis="dialogVis" ref="addmaterials"></selector>
        <el-dialog v-dialogDrag :visible.sync="isShowTransfer" :title="$t('getapi[6023]')" width="20%">
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[1480]')}}</td>
                        <td>
                            <el-input v-model="PlanNo" type="text" size="mini" style="width:120px"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[4158]')}}</td>
                        <td>
                            <el-input
                                    v-model="item_code"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width:120px"
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectItem_code()"></i>
                            </el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowTransfer = false" size="mini">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmTransfer(0)" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <!--<itemCode :isVisible="isShowItem" @getproject="getproject" ref="input"></itemCode>-->
        <selector :isVisible="isShowItem" :selectType="0" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEngItemDataList'" @callback="getproject" ref="input"></selector>
        <!-- 改变表格顺序 -->
        <ctable :isVisible="false" :title="title" queryData="FrmSimulation" :tabNo="tabNo" ref="ctab"
                @getctab="sortclick"></ctable>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'schemesimulation',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight-180,
                    maxHeight: this.$windowSize.tableHeight-180,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSetMaterials: [], //物料
                dataSetPlanNumber: [], //计划清单
                dataSetDetails1: {
                    ColumnsList: [],
                    DataList: []
                }, //模拟配料
                dataSetDetails2: {
                    ColumnsList: [],
                    DataList: []
                },
                dataSetDetails3: {
                    ColumnsList: [],
                    DataList: []
                },
                loading: false,
                addmaterialsvisible: false, // 新增物料弹窗
                selectIDData: [], // 物料多选ID合集
                selectIDPlanData: [], // 物料多选ID合集
                selectIndex: 0, // 分页
                select1Data: [], // 多选（按采购件新算法）
                select2Data: [], // 多选（按采购件）
                PlanNo: '', // 计划标识
                item_code: '', // 项目编码
                isShowTransfer: false,
                isShowItem: false,
                reduceTableHeight: Common.reduceTableHeight1_1,
                tabNo: "0",
                tableHeader: [],
                tableHeader1: [],
                tableHeader2: [],
                activeName: '1',
                title: "",
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
            };
        },
        mounted: function () {
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.$limits.dragControllerDiv1();
            that.authority();
            that.colsort();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop3;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[100]"),this.$t("getapi[16]"));
            },
            // 修改表格顺序
            opentable() {
                // console.log("测试:"+this.tabNo);
                this.$refs.ctab.clearInputs(true);
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('FrmSimulation', that.tabNo, PFileds => {
                    if (that.tabNo == 0) {
                        that.tableHeader = PFileds;
                    }
                    else if (that.tabNo == 1) {
                        that.tableHeader1 = PFileds;
                        for(let i = 0;i<that.tableHeader1.length;i++){
                            if(that.tableHeader1[i].prop == 'needqt'){
                                that.tableHeader1[i].titlehelp = that.$t('getapi[12362]')
                            }
                            if(that.tableHeader1[i].prop == 'psoneedqty'){
                                that.tableHeader1[i].titlehelp = that.$t('getapi[12363]')
                            }
                            if(that.tableHeader1[i].prop == 'inventoryqty'){
                                that.tableHeader1[i].titlehelp = that.$t('getapi[12364]')
                            }
                            if(that.tableHeader1[i].prop == 'Inventorybalance'){
                                that.tableHeader1[i].titlehelp = that.$t('getapi[12365]')
                            }
                            if(that.tableHeader1[i].prop == 'mrpqty'){
                                that.tableHeader1[i].titlehelp = that.$t('getapi[12366]')
                            }
                            if(that.tableHeader1[i].prop == 'addorderbalance'){
                                that.tableHeader1[i].titlehelp = that.$t('getapi[12367]')
                            }
                        }
                    }
                    else if (that.tabNo == 2) {
                        that.tableHeader2 = PFileds;
                    }
                });
            },
            sortclick(val) {
                let that = this;
                if (val == 1) {
                    this.colsort();
                }
            },
            selpage() {
                let that = this;
                that.selectIndex = that.activeName;
                if (that.activeName == 1) {
                    that.tabNo = "0";
                    that.title = this.$t('getapi[8706]')//"模拟配料(新算法)";
                }
                else if (that.activeName == 2) {
                    that.tabNo = "1";
                    that.title = this.$t('getapi[8707]')//"模拟配料(按采购件)";
                }
                else if (that.activeName == 3) {
                    that.tabNo = "2";
                    that.title = this.$t('getapi[8708]')//"模拟配料(按料表)";
                } else {
                    that.tabNo = "0";
                    that.title = this.$t('getapi[100]')//"模拟配料";
                }
                that.$nextTick(function () {
                    that.$processdata.initForm(that.activeName)
                })
                // that.sortclick();
                that.colsort();
                // that.opentable();
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('export');
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            // 添加物料
            showAddMaterials() {
                let that = this;
                that.addmaterialsvisible = true;
                that.$refs.addmaterials.clearInput(that.addmaterialsvisible, true, 4);
            },
            dialogVis(val){
                let that = this;
                that.addmaterialsvisible = val;
            },
            addmaterials(data) {
                let that = this;
                that.addmaterialsvisible = false;
                for (let i = 0; i < data.length; i++) {
                    that.dataSetMaterials = [
                        ...that.dataSetMaterials,
                        {
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            exclusively_id: data[i].exclusively_id,
                            number: 1
                        }
                    ];
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].exclusively_id);
                }
            },
            // 计划单号清单批量选择
            handleSelectionPlanChange(val) {
                let that = this;
                that.selectIDPlanData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDPlanData.push(val[i].$index);
                }
            },
            // 批量删除
            batchEdl() {
                let that = this;
                let arr = that.dataSetMaterials.filter(item => {
                    return that.selectIDData.every(item2 => {
                        return item.exclusively_id != item2;
                    });
                });
                that.dataSetMaterials = arr;
            },
            // 计划单号清单批量删除
            batchEdlPlan() {
                let that = this;
                let arr = that.dataSetMaterials.filter(item => {
                    return that.selectIDData.every(item2 => {
                        return item.exclusively_id != item2;
                    });
                });
                that.dataSetMaterials = arr;
            },

            // 模拟配料切换
            selectInfo(val) {
                let that = this;
                if (val == 1) {
                    that.tabNo = "0";
                    that.title = this.$t('getapi[8706]')//"模拟配料(新算法)";
                }
                else if (val == 2) {
                    that.tabNo = "1";
                    that.title = this.$t('getapi[8707]')//"模拟配料(按采购件)";
                }
                else if (val == 3) {
                    that.tabNo = "2";
                    that.title = this.$t('getapi[8708]')//"模拟配料(按料表)";
                } else {
                    that.tabNo = "0";
                    that.title = this.$t('getapi[100]')//"模拟配料";
                }
                that.loading = true;
                that.selectIndex = val;
                that.activeName = val.toString()
                let partlist = [];
                for (let i = 0; i < that.dataSetMaterials.length; i++) {
                    partlist.push({
                        part_code: that.dataSetMaterials[i].part_code,
                        part_version: that.dataSetMaterials[i].part_version,
                        exclusively_id: that.dataSetMaterials[i].exclusively_id,
                        number: that.dataSetMaterials[i].number
                    });
                }
                let parm = {
                    SimulationType: val,
                    partlist: partlist,
                    plannolist: that.dataSetPlanNumber,
                    LangType: that.$processdata.getLang(),
                };
                console.log(JSON.stringify(parm));
                that.$http.urlpost('/Pur/Requisition/GetSimulationList', parm, function (res) {
                    if (res.Success == 1) {
                        if (val == 1) {
                            that.dataSetDetails1 = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initForm(1)
                            })
                        } else if (val == 2) {
                            that.dataSetDetails2 = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initForm(2)
                            })
                        } else if (val == 3) {
                            that.dataSetDetails3 = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initForm(3)
                            })
                        }
                    } else {
                        if (val == 1) {
                            that.dataSetDetails1 = [];
                        } else if (val == 2) {
                            that.dataSetDetails2 = [];
                        } else if (val == 3) {
                            that.dataSetDetails3 = [];
                        }
                    }
                    that.loading = false;
                });

                that.colsort();
            },
            //导出
            exps() {
                let that = this;
                //that.selectIndex = tab.name;
                that.loading = true;
                let partlist = [];
                for (let i = 0; i < that.dataSetMaterials.length; i++) {
                    partlist.push({
                        part_code: that.dataSetMaterials[i].part_code,
                        part_version: that.dataSetMaterials[i].part_version,
                        exclusively_id: that.dataSetMaterials[i].exclusively_id,
                        number: that.dataSetMaterials[i].number
                    });
                }
                let parm = {
                    SimulationType: that.selectIndex,
                    partlist: partlist,
                    plannolist: that.dataSetPlanNumber
                };
                console.log(JSON.stringify(parm));
                that.$http.urlpost('/Pur/Requisition/GetSimulationToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            // 新增计划单号清单
            showAddPlanNumber() {
                let that = this;
                that.dataSetPlanNumber = [
                    ...that.dataSetPlanNumber,
                    {
                        planno: ''
                    }
                ];
            },
            //  删除物料
            delMaterials(index) {
                let that = this;
                that.dataSetMaterials.splice(index, 1);
            },
            //  删除计划单号
            delPlanNumber(index) {
                let that = this;
                that.dataSetPlanNumber.splice(index, 1);
            },
            // 转单
            transfer() {
                let that = this;
                //console.log(JSON.stringify(that.select2Data))
                if (that.$limits.authority('plv4', 41, 1) == 0) {
                    that.$message.warning(that.$t('getapi[8760]'))//'没有转单权限!'
                    return false
                }
                that.isShowTransfer = true;
                that.PlanNo = ''
                that.item_code = ''
            },
            confirmTransfer(val) {
                let that = this;
                let parm;
                if (that.selectIndex == 1) {
                    parm = {
                        Type: that.selectIndex,
                        PlanNo: that.PlanNo,
                        item_code: that.item_code,
                        List: that.select1Data,
                        iscontinue: val
                    };
                } else if (that.selectIndex == 2) {
                    parm = {
                        Type: that.selectIndex,
                        PlanNo: that.PlanNo,
                        item_code: that.item_code,
                        List: that.select2Data,
                        iscontinue: val,
                        LangType: that.$processdata.getLang(),
                    };
                }
                that.$http.urlpost('/Pur/Requisition/GetSimulationToPlan', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.isShowTransfer = false;
                    } else if (res.Success == 2) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmTransfer(2)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            /*handleSelectionChange1(val) {
                let that = this;
                that.select1Data = [];
                for (let i = 0; i < val.length; i++) {
                    that.select1Data.push({
                        part_code: val[i].part_code,
                        part_version: val[i].part_version,
                        suggestneedqty: val[i].suggestneedqty,
                        purdays: val[i].purdays
                    });
                }
            },*/
            handleSelectionChange1({checked, records }){
                let that = this;
                that.select1Data = [];
                for (let i = 0; i < records.length; i++) {
                    that.select1Data.push({
                        part_code: records[i].part_code,
                        part_version: records[i].part_version,
                        suggestneedqty: records[i].suggestneedqty,
                        purdays: records[i].purdays
                    });
                }
            },
            handleSelectionChangeAll({ records }){
                let that = this
                that.select1Data = [];
                for (let i = 0; i < records.length; i++) {
                    that.select1Data.push({
                        part_code: records[i].part_code,
                        part_version: records[i].part_version,
                        suggestneedqty: records[i].suggestneedqty,
                        purdays: records[i].purdays
                    });
                }
            },
            handleSelectionChange2({checked, records }) {
                let that = this;
                that.select2Data = [];
                for (let i = 0; i < records.length; i++) {
                    that.select2Data.push({
                        part_code: records[i].part_code,
                        part_version: records[i].part_version,
                        suggestneedqty: records[i].suggestneedqty,
                        purdays: records[i].purdays
                    });
                }
            },
            handleSelectionChangeAll2({checked, records }) {
                let that = this;
                that.select2Data = [];
                for (let i = 0; i < records.length; i++) {
                    that.select2Data.push({
                        part_code: records[i].part_code,
                        part_version: records[i].part_version,
                        suggestneedqty: records[i].suggestneedqty,
                        purdays: records[i].purdays
                    });
                }
            },
            selectItem_code() {
                let that = this;
                that.isShowItem = true;
                that.$refs.input.clearInput(this.isShowItem);
            },
            getproject(val) {
                let that = this;
                that.item_code = val.item_name;
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if ((this.$route.name == this.$options.name) && (that.addmaterialsvisible == false)) {
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            check(datap) {
                let that = this
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                console.log('arr' + arr)
                let arrlist = []
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 1) {
                        arrlist = [...arrlist, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: '',
                            exclusively_id: '',
                            qty:1
                        }]
                    } else if (arr[i].split('\\t').length == 2) {
                        arrlist = [...arrlist, {
                            part_code: arr[i].split('\\t')[0],
                            qty: arr[i].split('\\t')[1],
                            part_version: ''
                        }]
                    } else if(arr[i].split('\\t').length == 3) {
                        that.dataSetMaterials = [...that.dataSetMaterials, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[2],
                            exclusively_id: '',
                            qty: arr[i].split('\\t')[1]
                        }]
                    }
                }
                if (arrlist.length > 0) {
                    let parm = {
                        list: arrlist
                    }
                    that.$http.urlpost('/Pur/Requisition/GetSimulationPasteByPartCode', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent.List
                            for (let i = 0; i < data.length; i++) {
                                that.dataSetMaterials = [...that.dataSetMaterials, {
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    exclusively_id: data[i].exclusively_id,
                                    number: data[i].number
                                }]
                            }
                        }
                    });
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
